import Validatable from '@/validator/Validatable';

export interface AIThreadAPI {
  message: string;
}

export default class AIThread extends Validatable<AIThread> {
  constructor(public thread: string = '') {
    super();
  }

  toApi(): AIThreadAPI {
    return {
      message: this.thread,
    };
  }

  static fromObject(obj: object) {
    return super.fromObject(obj, new AIThread());
  }

  static fromApi(apiObject: AIThreadAPI) {
    return new AIThread(apiObject.message);
  }
}
